import { useMutation, useQueryClient } from '@tanstack/react-query';
import { likeGoodsService } from 'shared/src/api';
import { queryKey as sharedQueryKey } from 'shared/src/constant';
import { queryKey } from '../../../constant/queryKey';

export const useMoveLikedGoods = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: likeGoodsService.bulkMove,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKey.folderDetailAll,
      });
      queryClient.invalidateQueries({
        queryKey: queryKey.folderDetailMetaAll,
      });
      queryClient.invalidateQueries({
        queryKey: sharedQueryKey.getInfiniteLikeFolders,
      });
    },
  });
};
